exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge[data-v-06bf085e]{width:145px;max-width:100%}.date[data-v-06bf085e]{font-size:14px}.fas[data-v-06bf085e]{color:#e30613}h2[data-v-06bf085e]{font-size:30px;font-weight:700;color:#18252d}.small-author[data-v-06bf085e]{font-weight:700;font-size:14px}.image[data-v-06bf085e]{width:210px}.small-title[data-v-06bf085e]{font-size:10px;color:#485767;font-weight:700;text-transform:uppercase;margin-bottom:15px}.endorsed-logo[data-v-06bf085e]{text-align:center}", ""]);

// exports
